import axiosBase, { AxiosInstance } from 'axios'
import { mapKeysCamelCase } from "./axios";

// misignal_calculatorと通信するためのaxiosのbaseが取得できる
const misignalCalculatorAxiosBase = (): AxiosInstance => {
    const headers: { 'Content-Type': string; Authorization?: string } = {
        'Content-Type': 'application/json',
        Authorization: process.env.REACT_APP_MISIGNAL_CALCULATOR_API_KEY
    }

    const base = axiosBase.create({
        baseURL: `https://0pbgihu926.execute-api.ap-northeast-1.amazonaws.com`,
        headers: headers,
        responseType: 'json',
    })

    // レスポンスを camelCase に変換する
    base.interceptors.response.use(
        (response: any) => {
            const { data } = response
            const convertedData = mapKeysCamelCase(data)
            return { ...response, data: convertedData }
        },
        (error: any) => {
            const { data } = error.response
            const convertData = mapKeysCamelCase(data)
            error.response.data = convertData
            return Promise.reject(error)
        }
    )
    return base
}

export default misignalCalculatorAxiosBase